import ReactDOM from "react-dom/client"
import {StrictMode} from "react";
import {BaSeDialogContainer, BaSeRoot} from "@base/react"
import App from "./App"
import {createBrowserRouter, RouterProvider} from "react-router-dom"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./animate.css"
import "./index.scss"

const root = ReactDOM.createRoot(document.getElementById("root"))

const router = createBrowserRouter([{ path: "*", element: <App /> }])

const TemplateRoot = () => {
  return (
    <BaSeRoot locale="pt-BR" withResetCss={true}>
      <RouterProvider router={router} />
      <BaSeDialogContainer />
    </BaSeRoot>
  )
}

if (process.env.REACT_APP_ENV === "development") {
  root.render(
    <StrictMode>
      <TemplateRoot />
    </StrictMode>
  )
} else {
  root.render(<TemplateRoot />)
}

serviceWorkerRegistration.unregister()
reportWebVitals()
